import { useRef } from "react";
import { createPortal } from "react-dom";

import { GalleryModal } from "./GalleryModal";
import { PreviewItem } from "./PreviewItem";

export const PreviewGrid = ({ images, remove, onlyView }) => {
  const previewRef = useRef(null);

  const onPreview = (index) => {
    previewRef.current?.open(index);
  };

  return (
    <>
      {images.length > 0 && (
        <div className="grid grid-cols-4 gap-4 mt-3">
          {images.map((image, index) => (
            <PreviewItem
              key={image.__id}
              image={image}
              index={index}
              remove={remove}
              onPreview={onPreview}
              onlyView={onlyView}
            />
          ))}
        </div>
      )}

      {createPortal(
        <GalleryModal images={images} ref={previewRef} />,
        document.body,
      )}
    </>
  );
};
